export const allowedBaseSubscriptionPaths = [
    "/cajas-online",
    "/perfil",
    "/novedades",
    "/login",
    "/rememberPass",
    "/serverdown",
    "/terms"
];

export const allowedPremiumSubscriptionPaths = [
    "/cajas-online",
    "/informes",
    "/informes/ventas/ventas-negocios",
    "/informes/ventas/ventas-negocios-zona-horaria",
    "/informes/ventas/ventas-comensales",
    "/informes/ventas/ventas-negocios-rango-mesas",
    "/informes/ventas/facturacion-general",
    "/informes/ventas/facturas-simplificadas",
    "/informes/ventas/facturas-nominativas",
    "/informes/ventas/facturas-nominativas-qr",
    "/informes/ventas/ventas-rectificadas",
    "/informes/ventas/ventas-anuladas",
    "/informes/ventas/formas-pago",
    "/informes/ventas/agencias",
    "/informes/ventas/cuentas-aparcadas",
    "/informes/ventas/impuestos-cierre",
    "/informes/ventas/retiradas",
    "/informes/proveedores/gastos-proveedores",
    "/informes/proveedores/gastos-general-proveedor",
    "/informes/proveedores/gastos-etiquetas",
    "/informes/clientes/ventas-clientes",
    "/informes/clientes/consultar-ventas-clientes",
    "/informes/clientes/consultar-ventas-productos-cliente",
    "/informes/productos/ventas-productos",
    "/informes/productos/coste-productos",
    "/informes/productos/coste-productos-agencias",
    "/informes/productos/historico-productos",
    "/informes/productos/ventas-productos-global",
    "/informes/categorias/ventas-categorias",
    "/informes/productos/ventas-productos-por-rango-de-mesas",
    "/informes/productos/invitaciones",
    "/informes/casas/gastos-casas",
    "/informes/casas/compras-casas",
    "/informes/pedidos/pedidos-pasarela-pago-redsys",
    "/informes/ventas/informe-pedidos",
    "/informes/ventas/informe-ventas-productos-pedidos",
    "/informes/pedidos/pedidos-repartidores",
    "/informes/materias-primas/ventas-materias-primas",
    "/informes/materias-primas/gastos-materias-primas",
    "/informes/operarios/ventas-operarios",
    "/informes/operarios/turnos-operarios",
    "/informes/operarios/aperturas-operarios",
    "/informes/operarios/incidencias-operarios",
    "/informes/informes/ventas/vales-clientes",
    "/configuracion/productos",
    "/configuracion/categoriasGenerales",
    "/configuracion/modificadores",
    "/configuracion/clientes",
    "/configuracion/rangos-horarios",
    "/configuracion/rangos-de-mesas",
    "/configuracion/materias-primas",
    "/configuracion/proveedores",
    "/configuracion/casas",
    "/configuracion/categorias",
    "/configuracion/agencias",
    "/configuracion/configuracion-almacen",
    "/configuracion/operarios",
    "/configuracion/formas-de-pago",
    "/configuracion/herramientas",
    "/pedidos-proveedor",
    "/gestion-gastos",
    "/almacen",
    "/historial-almacen",
    "/detalle-almacen",
    "/detalle-materia-prima-almacen",
    "/posicion-global",
    "/calendar",
    "/soporte-online",
    "/configuracion",
    "/entrada-almacen",
    "/control-inventario",
    "/inventario",
    "/gestion-gasto",
    "/novedades",
    "/login",
    "/rememberPass",
    "/serverdown",
    "/terms"
];

import store from "../store/store";

export function checkPermisos(to) {
    const listBusinesses = store.state.xlistBusiness;
    const xidBusiness = store.getters.idBusiness;
    let businessFound = listBusinesses.find((business) => business.id == xidBusiness);
    
    // console.log(listBusinesses);
    // Si no lo encuentra no hace nada
  
    if (businessFound == undefined) {
      businessFound = listBusinesses[0];
    }
    
    if (businessFound) {
        // Comprobamos si es suscripción capada
        // console.log(businessFound);

        if (businessFound.access == 0) {
            if (!allowedBaseSubscriptionPaths.includes(to.path)) {
                // console.log("no tiene permiso")
                store.commit("changePermiso", false);
            } else {
                console.log("tiene permiso")
                store.commit("changePermiso", true);
            }
        // O suscripción premium
        } else if (businessFound.access == 1) {
            if (!allowedPremiumSubscriptionPaths.some(path => to.path.startsWith(path))) {
              // console.log("no tiene permiso")
              store.commit("changePermiso", false);
            } else {
              // console.log("tiene permiso")
              store.commit("changePermiso", true);
            }
        } else {
              // console.log("tiene permiso")
              store.commit("changePermiso", true);
        }
    }
    
    
    /*if (businessFound != undefined) {
      
      //Comprobamos si es suscripción capada
      if (businessFound.access == 0) {
        if (!allowedBaseSubscriptionPaths.includes(to.path)) {
          store.commit("changePermiso", false);
        } else {
          store.commit("changePermiso", true);
        }
      //O suscripción premium
      } else if (businessFound.access == 1) {
        console.log(!allowedPremiumSubscriptionsPaths.includes(to.path));
        if (!allowedPremiumSubscriptionsPaths.includes(to.path)) {
          store.commit("changePermiso", false);
        } else {
          store.commit("changePermiso", true);
        }
      } else {
        store.commit("changePermiso", true);
      }
          
    } else {
  
      businessFound = listBusinesses[0];
  
      //Comprobamos si es suscripción capada
      if (businessFound.access == 0) {
        if (!allowedBaseSubscriptionPaths.includes(to.path)) {
          store.commit("changePermiso", false);
        } else {
          store.commit("changePermiso", true);
        }
      //O suscripción premium
      } else if (businessFound.access == 1) {
        console.log(!allowedPremiumSubscriptionsPaths.includes(to.path));
        if (!allowedPremiumSubscriptionsPaths.includes(to.path)) {
          store.commit("changePermiso", false);
        } else {
          store.commit("changePermiso", true);
        }
      } else {
        store.commit("changePermiso", true);
      }
    }*/
  }


// WEBPACK FOOTER //
// ./src/routes/subscription-routes.js